import selfawarenessImg from "../../../img/test-images/EI-result-images/self-awareness.svg";
import managingemotionsImg from "../../../img/test-images/EI-result-images/managing-emotions.svg";
import motivatingImg from "../../../img/test-images/EI-result-images/motivating-oneself.svg";
import empathyImg from "../../../img/test-images/EI-result-images/empathy.svg";
import relationshipsImg from "../../../img/test-images/EI-result-images/handling-relationships.svg";

const questions = [
  "I can easily impress others",
  "I get anxious whenever my exam result is about to be declared",
  "I perceive clear goals in my life with a 'can do' attitude",
  "I take view points from others while looking at or analyzing a situation",
  "I feel confident while talking to a new person ",
  "I can take criticism regarding my physique in a healthy manner",
  "Day-dreaming is good for diverting attention",
  "I mostly set aside some time for relaxation everyday to relieve myself from a stressful life",
  "I tend to easily move to tears or laughter",
  "It is always wise to avoid an argument",
  "I feel jealous when people give compliments to my friends and not me",
  "I easily get aggressive with my friends",
  "I accept myself as I am; with all my strengths and weaknesses",
  "I am temperamentally more prone to be skeptic than a believer in God",
  "It is okay if parents satisfy demands of younger siblings prior to my demands",
  "I am academically brilliant in my class",
  "I try to divert my attention to something positive while feeling depressed",
  "There is always a chance to correct your mistakes",
  "I would rather listen to a story than tell one",
  "It is better to talk less than being labelled as a talkative person",
  "I am capable of handling every situation in my life",
  "I find myself tensed up because of petty things in life",
  "I believe in the 'try, try, try, again, until you succeed' theory",
  "I easily believe in the excuses that others give for not doing a job",
  "I feel adults impose things on me",
  "I get upset upon missing an opportunity in life",
  "Hurting someone to make one-self happy is okay",
  "Frequent rewards can increase my performance",
  "I correct others not because they are wrong but because they irritate me",
  "I find myself criticizing others too often",
  "I get irritated and depressed when I am unable to solve a given problem",
  "I think success depends on what we say and how we say it",
  "I feel motivated to do a job in the right manner",
  "I feel it is alright to help others financially even when I can't afford it",
  "I can learn from the mistakes of others",
  "I feel shy when in a group",
  "I blame failures on situations",
  "I believe in forgiving others rather than remembering their misdeeds",
  "I try to remain calm while discussing sensitive/controversial issues",
  "I become the center of attraction everwhere that I go",
  "I am capable of doing any work in life if I am interested in doing it",
  "I feel guilty for not helping others when I could",
  "I apologize for my behaviour if I feel I am wrong",
  "I am liked by everyone",
  "It is better to check oneself rather than being checked by others",
  "I can play jokes on myself like I play at others",
  "I can get dishonest when the need arises",
  "One should take help of a counsellor/friend to resolve a conflict/problem if they can't manage it on their own",
  "I help others at the time of need",
  "I can handle a situation better than others can handle it",
  "I leave my job in between if I find it to be very difficult",
  "I act/behave with keeping my interests as priority",
  "There is usually a disagreement between my brain and my heart regarding what I should do",
  "I can easily get involved in gossiping",
  "I find myself satisfied in life",
  "I face ego problems when I have to apologize",
  "I use words like 'sorry' and 'thank you' quite often",
  "I believe that nobody is perfect and there is a scope for improvement for everyone",
  "In matters of conduct, I prefer to conform to the expected norms",
  "I think everybody is right at their own place",
];

const overallResultData = [
  "It suggests that you are able to understand your emotions and of those around you. You also tend to think before you act and have a good personal as well as professional relationship with the people around you.",
  "It suggests that you have a good grasp on the emotional states of those around you and you are aware of the effects your actions and emotions can have on others.",
  "It suggests that you might have difficulties in understanding emotions, and how your actions can affect others. You might have a tendency to refuse to listen to other’s opinions, and have a tendency to act before you think.",
];

const domainData = [
  {
    key: 1,
    src: selfawarenessImg,
    domainName: "Self Awareness",
    desc:
      "The ability to recognize and understand your own emotions is a critical part of Emotional Intelligence. Beyond just recognizing your own emotions, however, is being aware of the effect of your actions, moods, and emotions on other people.",
    color: "",
  },
  {
    key: 2,
    src: managingemotionsImg,
    domainName: "Managing Emotions",
    desc:
      "The ability to stay focused and think clearly even when you might be experiencing powerful emotions. Being able to manage your own emotional state is essential for taking responsibility for your actions, and can save you from hasty decisions that you might later regret.",
    color: "",
  },
  {
    key: 3,
    src: motivatingImg,
    domainName: "Motivating Oneself",
    desc:
      "The ability to use your deepest emotions to move and guide you towards your goals. This ability enables you to take the initiative and to persevere in the face of obstacles and setbacks.",
    color: "",
  },
  {
    key: 4,
    src: empathyImg,
    domainName: "Empathy",
    desc:
      "The ability to sense, understand and respond to what other people might be feeling. Self-awareness is essential in having empathy towards others. If you are not aware of your own emotions, you will not be able to read the emotions of others.",
    color: "",
  },
  {
    key: 5,
    src: relationshipsImg,
    domainName: "Handling Relationships",
    desc:
      "The ability to handle emotions in relationships and using your awareness of your own emotions, and those of others, to manage interactions successfully.",
    color: "",
  },
];

export { questions, overallResultData, domainData };
